<script>
import HeroSection from '@site/components/home/HeroSection.vue'
import NovaLaunchSection from '@site/components/home/NovaLaunchSection.vue'
import PainPointsSection from '@site/components/home/PainPointsSection.vue'
import IndustrySection from '@site/components/home/IndustrySection.vue'
import DualProductSection from '@site/components/home/DualProductSection.vue'
import FeatureSection from '@site/components/home/FeatureSection.vue'
import MobileSection from '@site/components/home/MobileSection.vue'
import CaseSection from '@site/components/home/CaseSection.vue'
import StatsSection from '@site/components/home/StatsSection.vue'
import BottomCtaSection from '@site/components/home/BottomCtaSection.vue'
import FaqSection from '@site/components/home/FaqSection.vue'

export default {
  name: 'HomeView',
  components: {
    HeroSection,
    NovaLaunchSection,
    PainPointsSection,
    IndustrySection,
    DualProductSection,
    FeatureSection,
    MobileSection,
    CaseSection,
    StatsSection,
    BottomCtaSection,
    FaqSection,
  },
}
</script>

<template>
  <main>
    <HeroSection />
    <NovaLaunchSection />
    <PainPointsSection />
    <IndustrySection />
    <DualProductSection />
    <FeatureSection />
    <MobileSection />
    <CaseSection />
    <StatsSection />
    <FaqSection />
    <BottomCtaSection />
  </main>
</template>



// WEBPACK FOOTER //
// src/site/views/HomeView.vue